export enum TipoServicio {
    Indeterminado = 0,
    Alije = 1,
    Rancho = 2,
    AlijeVariable = 3,
    Clase3 = 4
}

export class TipoServicioUtil {
    static getDescripcionPorClave(key: TipoServicio): string {
        switch (key) {
            case TipoServicio.Indeterminado:
                return 'Indeterminado';
            case TipoServicio.Alije:
                return 'Alije';
            case TipoServicio.Rancho:
                return 'Rancho';
            case TipoServicio.AlijeVariable:
                return 'Alije Variable';
            case TipoServicio.Clase3:
                return 'IATA Nivel 2/3';
            default:
                return 'Descripción no encontrada';
        }
    }
}